import { render, staticRenderFns } from "./ModalAddNewTeam.vue?vue&type=template&id=5ff77e0b&scoped=true&"
import script from "./ModalAddNewTeam.vue?vue&type=script&lang=js&"
export * from "./ModalAddNewTeam.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddNewTeam.vue?vue&type=style&index=0&id=5ff77e0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff77e0b",
  null
  
)

export default component.exports